import React, { useState } from "react";
import useStyle from "./useStyle";
import { Checked } from "../Checkbox";
import listUtils from "utils/listUtils";
import SelectAll, { SelectAllCheckboxesProps } from "../SelectAll";
import Searchbox from "../Searchbox";
import utils from "utils";
import ScrollPanel from "components/layouts/ScrollPanel";

export interface FilteredSelectionsItemProps {
  value: string;
  isSelected: boolean;
}

export interface FilterDropdownProps {
  items: FilteredSelectionsItemProps[];
  onItemsChange: (items: FilteredSelectionsItemProps[]) => void;
}

type ComponentState = {
  valueFilter?: string;
};

const FilteredSelections: React.FC<FilterDropdownProps> = function (props) {
  const [state, setState] = useState<ComponentState>({});
  const classes = useStyle(props);
  const filteredItems = props.items.filter((item) =>
    utils.stringContainsCaseInsensitive(item.value, state.valueFilter || "")
  );

  // Items filtered out by the current search text are deselected. The prior
  // implementation did this with a triple-nested loop (O(n^3)) that ran
  // eagerly for every column's (closed) filter overlay; this is the O(n)
  // equivalent and produces the same checkbox list / selection side effect.
  const matchingValues = new Set(filteredItems.map((item) => item.value));
  props.items.forEach((item) => {
    if (!matchingValues.has(item.value)) {
      item.isSelected = false;
    }
  });

  const checkboxes: SelectAllCheckboxesProps[] = filteredItems.map((item) => {
    return {
      label: item.value,
      checked: item.isSelected,
      labelPosition: "right",
      onChange: (checked: Checked) => {
        const isSelected = checked === true;
        const newItems = listUtils.copyListWithNewCustomKeyedItem(
          props.items,
          { ...item, isSelected: isSelected },
          "value"
        );

        props.onItemsChange(
          listUtils.sortItemsBySingleKeyedItem(newItems, "value")
        );
      }
    };
  });

  const numberOfSelectedItems = props.items.filter(
    (item) => item.isSelected
  ).length;
  const numberOfItemsTotal = filteredItems.length;
  const informationText =
    numberOfItemsTotal > 0
      ? `${numberOfSelectedItems} selected`
      : "No results found";

  return (
    <div className={classes.innerRoot}>
      <div className={classes.searchBox}>
        <Searchbox
          label="Filter"
          value={state.valueFilter}
          onChange={(v) => setState({ ...state, valueFilter: v })}
          mode="filter"
        />
      </div>
      <ScrollPanel heightInPixels={250}>
        <div className={classes.resultsMessage}>{informationText}</div>
        <SelectAll
          checkboxes={listUtils.sortItemsBySingleKeyedItem(checkboxes, "label")}
          onChange={(checked: Checked) => {
            const isSelected = checked === true;
            const newItems = props.items.map((item) => {
              return { ...item, isSelected: isSelected };
            });

            props.onItemsChange(
              listUtils.sortItemsBySingleKeyedItem(newItems, "value")
            );
          }}
          hideSelectAll={!utils.stringIsNullOrEmpty(state.valueFilter)}
        />
      </ScrollPanel>
    </div>
  );
};

export default FilteredSelections;
